'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
const disabledDiagnostics = {
    xrLocomotion: false,
    ringGeometry: false,
    cameraGraph: false,
    guidance: false,
    cameraInspection: false,
};
const VisualizationDiagnosticsContext = createContext(disabledDiagnostics);
/** Wrap the persistent SpaceCanvasHost and its runtimes so both share reactive options. */
export function VisualizationDiagnosticsProvider(props) {
    return _jsx(VisualizationDiagnosticsContext.Provider, { value: props.options ?? disabledDiagnostics, children: props.children });
}
export function useVisualizationDiagnostics() {
    return useContext(VisualizationDiagnosticsContext);
}
let xrDiagnosticReporter;
/** Lets the host ship XR locomotion samples (while xrLocomotion diagnostics are on) somewhere it can read them. */
export function setXrDiagnosticReporter(reporter) {
    xrDiagnosticReporter = reporter;
    return () => { if (xrDiagnosticReporter === reporter)
        xrDiagnosticReporter = undefined; };
}
export function reportXrDiagnostic(sample) {
    xrDiagnosticReporter?.(sample);
}
